'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';
import { clerkInstance, clerkLoadedPromise } from '@/clerk-instance';

type ClerkContextType =
  | {
      clerk: null;
      isLoaded: false;
    }
  | {
      clerk: typeof clerkInstance;
      isLoaded: true;
    };

const ClerkContext = createContext<ClerkContextType>({
  clerk: null,
  isLoaded: false,
});

export const ClerkProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    clerkLoadedPromise.then(() => setIsLoaded(true));
  }, []);

  return (
    <ClerkContext.Provider
      value={
        isLoaded
          ? { clerk: clerkInstance, isLoaded }
          : { clerk: null, isLoaded }
      }
    >
      {children}
    </ClerkContext.Provider>
  );
};

export const useClerk = (): ClerkContextType => {
  const context = useContext(ClerkContext);
  if (!context) {
    throw new Error('useClerk must be used within a ClerkProvider');
  }

  return context;
};
